var _g, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlantasPet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1279_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6717C1 7.56876 7.56876 1 15.6717 1L37 1V22.3283C37 30.4312 30.4312 37 22.3283 37H1L1 15.6717Z",
    fill: "#69BF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1557 1V0.844262H37L15.6717 0.844262C7.48275 0.844262 0.844262 7.48275 0.844262 15.6717L0.844262 37V37.1557H1H22.3283C30.5173 37.1557 37.1557 30.5173 37.1557 22.3283V1Z",
    stroke: "url(#paint0_linear_1279_687)",
    strokeWidth: 0.311475
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1048 18.5772C14.2672 18.5772 15.2095 17.6348 15.2095 16.4724C15.2095 15.31 14.2672 14.3676 13.1048 14.3676C11.9423 14.3676 11 15.31 11 16.4724C11 17.6348 11.9423 18.5772 13.1048 18.5772Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8934 15.2095C18.0558 15.2095 18.9981 14.2672 18.9981 13.1048C18.9981 11.9423 18.0558 11 16.8934 11C15.7309 11 14.7886 11.9423 14.7886 13.1048C14.7886 14.2672 15.7309 15.2095 16.8934 15.2095Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9448 15.2095C23.1073 15.2095 24.0496 14.2672 24.0496 13.1048C24.0496 11.9423 23.1073 11 21.9448 11C20.7824 11 19.84 11.9423 19.84 13.1048C19.84 14.2672 20.7824 15.2095 21.9448 15.2095Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7334 18.5772C26.8958 18.5772 27.8382 17.6348 27.8382 16.4724C27.8382 15.31 26.8958 14.3676 25.7334 14.3676C24.571 14.3676 23.6286 15.31 23.6286 16.4724C23.6286 17.6348 24.571 18.5772 25.7334 18.5772Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9149 20.985C23.1824 20.1263 22.5679 19.3938 21.827 18.5351C21.4397 18.0805 20.943 17.6258 20.3536 17.4238C20.261 17.3901 20.1684 17.3648 20.0758 17.348C19.8653 17.3143 19.638 17.3143 19.4191 17.3143C19.2002 17.3143 18.9729 17.3143 18.754 17.3564C18.6614 17.3733 18.5688 17.3985 18.4762 17.4322C17.8868 17.6342 17.3985 18.0889 17.0028 18.5435C16.2704 19.4023 15.6558 20.1347 14.9149 20.9935C13.812 22.0964 12.4565 23.3171 12.7091 25.0262C12.9532 25.885 13.5678 26.7353 14.6707 26.9794C15.2853 27.1057 17.247 26.609 19.3349 26.609H19.4865C21.5744 26.609 23.536 27.0973 24.1506 26.9794C25.2535 26.7353 25.8681 25.8765 26.1123 25.0262C26.3733 23.3087 25.0178 22.0879 23.9149 20.985Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1279_687",
    x: -2.75015,
    y: -2.75021,
    width: 43.5003,
    height: 43.5004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1.71934
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1279_687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1279_687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1279_687",
    x1: 11.2857,
    y1: -4.90164,
    x2: 30.9983,
    y2: 43.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantasPet);
export default __webpack_public_path__ + "static/media/plantasPet.d3a83fff27f41854dd23f476e711adc2.svg";
export { ForwardRef as ReactComponent };